import { useState } from 'react';

const faqs = [
  {
    q: 'Ce capital minim am nevoie pentru a începe în Forex?',
    a: 'Tehnic poți începe cu orice sumă, dar recomandarea generală este un cont demo timp de 3-6 luni, urmat de un cont real cu minimum 500-1.000 USD. Unii brokeri acceptă și 50-100 USD, dar cu sume mici este dificil să aplici corect managementul riscului.',
  },
  {
    q: 'Forex este sigur? Este o înșelătorie?',
    a: 'Forex-ul în sine este legitim și reglementat — este cea mai mare piață financiară din lume. Există însă escrocherii și brokeri nereglementați. Alege întotdeauna brokeri licențiați de autorități recunoscute (FCA, ASIC, CySEC). Tranzacționarea implică risc real de pierdere.',
  },
  {
    q: 'Cât timp durează să devii profitabil în Forex?',
    a: 'Realitatea este că cei mai mulți traderi au nevoie de 1-3 ani de studiu și practică pentru a deveni constant profitabili. Nu te lăsa păcălit de promisiuni de îmbogățire rapidă. Succesul vine din educație, disciplină și experiență acumulată treptat.',
  },
  {
    q: 'Care sunt cele mai tranzacționate perechi valutare?',
    a: 'Perechile majore includ EUR/USD (cel mai tranzacționat), GBP/USD, USD/JPY, USD/CHF, AUD/USD, USD/CAD și NZD/USD. Toate implică Dolarul American. EUR/USD singur reprezintă aproximativ 28% din volumul zilnic total al pieței Forex.',
  },
  {
    q: 'Ce diferență este între analiза tehnică și analiza fundamentală?',
    a: 'Analiza tehnică studiază graficele și mișcările de preț din trecut pentru a prezice direcția viitoare. Analiza fundamentală studiază factori economici — rate de dobândă, inflație, date economice, geopolitică. Cei mai buni traderi combină ambele tipuri de analiză.',
  },
  {
    q: 'Ce este un broker Forex și cum aleg unul bun?',
    a: 'Brokerul este intermediarul care îți oferă acces la piața Forex. Criterii esențiale: reglementare de o autoritate serioasă, spread-uri competitive, platformă de trading bună, depozit minim accesibil, suport în limba ta și recenzii pozitive din comunitate. Evită brokerii offshore nereglementați.',
  },
  {
    q: 'Pot tranzacționa Forex în România?',
    a: 'Da, tranzacționarea Forex este legală în România. Poți folosi brokeri reglementați de ESMA (regulatorul european). Câștigurile din Forex sunt impozabile — 10% impozit pe câștigurile de capital. Consultă un contabil pentru detalii fiscale actualizate.',
  },
  {
    q: 'Ce este un lot și cum calculez dimensiunea pozițiilor?',
    a: 'Un lot standard = 100.000 unități din moneda de bază. Un mini-lot = 10.000 unități, micro-lot = 1.000 unități. Dimensiunea corectă a poziției se calculează în funcție de capitalul disponibil, nivelul stop-loss și procentul de risc acceptat (1-2%). Folosește un calculator Forex pentru calcule rapide.',
  },
];

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span
            className="inline-block text-sm font-semibold uppercase tracking-widest mb-4 px-4 py-1 rounded-full"
            style={{ background: 'rgba(78,205,196,0.12)', color: '#4ecdc4' }}
          >
            06 — Întrebări Frecvente
          </span>
          <h2
            className="text-4xl md:text-5xl font-bold leading-tight mb-4"
            style={{ fontFamily: 'Playfair Display, serif', color: '#0f1419' }}
          >
            Întrebări Frecvente
            <br />
            despre Forex
          </h2>
          <p className="text-gray-500 text-lg">
            Răspunsuri la cele mai comune întrebări ale începătorilor
          </p>
        </div>

        {/* Accordion */}
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-2xl border overflow-hidden transition-all duration-300 cursor-pointer"
              style={{ borderColor: openIdx === i ? '#4ecdc4' : '#e5e7eb', background: openIdx === i ? 'rgba(78,205,196,0.03)' : 'white' }}
              onClick={() => setOpenIdx(openIdx === i ? null : i)}
            >
              <div className="flex items-center justify-between px-6 py-4 gap-4">
                <h3
                  className="text-base font-semibold flex-1"
                  style={{ color: openIdx === i ? '#0f1419' : '#374151' }}
                >
                  {faq.q}
                </h3>
                <div
                  className="w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300"
                  style={{ background: openIdx === i ? '#4ecdc4' : '#f3f4f6' }}
                >
                  <i
                    className={`ri-${openIdx === i ? 'subtract' : 'add'}-line text-sm`}
                    style={{ color: openIdx === i ? '#fff' : '#6b7280' }}
                  ></i>
                </div>
              </div>

              {openIdx === i && (
                <div className="px-6 pb-5">
                  <div className="w-full h-px mb-4" style={{ background: 'rgba(78,205,196,0.2)' }}></div>
                  <p className="text-gray-600 leading-relaxed text-sm">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div
          className="mt-16 rounded-3xl p-8 text-center"
          style={{ background: '#0f1419' }}
        >
          <div className="w-14 h-14 flex items-center justify-center rounded-full mx-auto mb-5" style={{ background: 'rgba(78,205,196,0.15)' }}>
            <i className="ri-chat-smile-2-line text-2xl" style={{ color: '#4ecdc4' }}></i>
          </div>
          <h3 className="text-2xl font-bold text-white mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
            Ai mai multe întrebări?
          </h3>
          <p className="text-gray-400 mb-6 text-sm">
            Comunitatea noastră de traderi este gata să te ajute în orice moment
          </p>
          <a
            href="#footer"
            onClick={(e) => { e.preventDefault(); document.querySelector('#footer')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="inline-flex items-center gap-2 px-7 py-3 rounded-full text-sm font-semibold whitespace-nowrap transition-opacity duration-200 hover:opacity-90 cursor-pointer"
            style={{ background: '#4ecdc4', color: '#0f1419' }}
          >
            <i className="ri-mail-line"></i>
            Abonează-te la Newsletter
          </a>
        </div>
      </div>
    </section>
  );
}
